export const primaryGranularities = ["raw", "daily", "weekly", "monthly"];

export const secondaryGranularities = ["avg", "min-avg-max"];

export const secondaryGranularitiesForComparison = ["avg", "min-avg-max"];

export const axisColors = ["#7855FF", "#FF7557", "#F8BB3A", "#229087"];

export const allMetrics = [
    {
        key: "current",
        label: "Current (A)",
        name: "Current",
        unit: "A",
        color: '#7855FF',
        yAxisDecimalPlaces: 2,
        ranges: { min: -20, max: 20, },
        data: [],
    },
    {
        key: "voltage",
        label: "Voltage (V)",
        name: "Voltage",
        color: '#FF7557',
        unit: "V",
        yAxisDecimalPlaces: 2,
        ranges: { min: 10, max: 100, },
        data: [],
    },
    {
        key: "soc",
        label: "SOC (%)",
        name: "SOC",
        color: '#F8BB3A',
        yAxisDecimalPlaces: 2,
        unit: "%",
        ranges: { min: 0, max: 100 },
        data: [],
    },
    {
        key: "temperature",
        label: "Max. Temperature (°C)",
        name: "Max. Temperature",
        unit: "°C",
        color: '#229087',
        yAxisDecimalPlaces: 2,
        ranges: { min: -20, max: 80 },
        data: [],
    },
    {
        key: "balanceState",
        label: "Cell Imbalance (mV)",
        name: "Cell Imbalance",
        color: '#581845',
        unit: "mV",
        yAxisDecimalPlaces: 2,
        ranges: { min: 0, max: 20, },
        data: [],
    },
    {
        key: 'capacity',
        label: 'Capacity (Ah)',
        name: 'Capacity',
        unit: 'Ah',
        yAxisDecimalPlaces: 2,
        color: "#00CED1",
        ranges: { min: 0, max: 100, },
        data: [],
    },
    {
        key: 'energy',
        label: 'Energy Used (kWh)',
        name: 'Energy Used',
        unit: 'kWh',
        yAxisDecimalPlaces: 2,
        color: "#DAF7A6",
        ranges: { min: 0, max: 4, },
        data: [],
    },
];

export const multiplyFactors = {
    energy: 0.001,
    cell_imbalance: 1000, // alternate name for balanceState
    balanceState: 1000,
    current: 1,
    voltage: 1,
    soc: 1,
    temperature: 1,
    capacity: 1,
    health: 1,
};

export const decimalPlacesForMetrics = {
    current: 2,
    voltage: 2,
    soc: 0,
    temperature: 2,
    capacity: 2,
    energy: 2,
    health: 1,
    balanceState: 3,
};

export const chartColorCodes = [
    "#783DFF",
    "#FF6D57",
    "#F8BB3B",
    "#30918F",
    "#84BCEF",
    "#DC7D85",
    "#42DD80",
    "#3E5AAB",
    "#CC97FF",
    "#1C1C52",
    "#FF32BE",
    "#6D009C",
    "#A15628",
    "#7B0C3F",
    "#C91640",
    "#006E23",
    "#F79819",
    "#B25486",
    "#00CED1",
    "#A8A638",
];

export const disabledMetricsForLevel = {
    battery: [],
    pack: [],
    module: ["soc", "capacity", "energy"],
    cell: ["soc", "capacity", "balanceState", "energy"]
}


export const alertTagStyles = {
    is_active: {
        active: {
            backgroundColor: '#EEF4DB',
            fontColor: '#3D7A45',
        },
        inactive: {
            backgroundColor: '#F9F9F9',
            fontColor: '#828282',
        },
        expired: {
            backgroundColor: '#FDE7E7',
            fontColor: '#B50500',
        },
        default: {
            backgroundColor: '#F9F9F9',
            fontColor: '#828282',
        },
    },
    alertStatus: {
        active: {
            backgroundColor: '#FFE4E4',
            fontColor: '#3D4B5A',
            iconColor: '#B50500',
        },
        resolved: {
            backgroundColor: '#EEF4DB',
            fontColor: '#3D4B5A',
            iconColor: '#008A15',
        },
        expired: {
            backgroundColor: '#F9F9F9',
            fontColor: '#3D4B5A',
            iconColor: '#828282',
        },
        default: {
            backgroundColor: '#FFE4E4',
            fontColor: '#3D4B5A',
            iconColor: '#B50500',
        }
    },
    severityName: {
        critical: {
            backgroundColor: '#FFE4E4',
            fontColor: '#930500',
        },
        high: {
            backgroundColor: '#FFE4E4',
            fontColor: '#930500',
        },
        medium: {
            backgroundColor: '#FFE9DB',
            fontColor: '#CC4E01',
        },
        low: {
            backgroundColor: '#FEF1C6',
            fontColor: '#AD7F00',
        },
        default: {
            backgroundColor: '#FFE4E4',
            fontColor: '#3D4B5A',
        }
    },
    severity: {
        critical: {
            backgroundColor: '#FFE4E4',
            fontColor: '#B50500',
        },
        'high severity': {
            backgroundColor: '#FFE9DB',
            fontColor: '#FF6B0F',
        },
        warning: {
            backgroundColor: '#FFF4CF',
            fontColor: '#C79201',
        },
        default: {
            backgroundColor: '#FFF4CF',
            fontColor: '#C79201',
        },
    },
    bmsAlertStatus: {
        open: {
            backgroundColor: '#2859E0',
            fontColor: '#FFFFFF',
        },
        resolved: {
            backgroundColor: '#008A15',
            fontColor: '#EEF4DB',
        },
        'in progress': {
            backgroundColor: '#E8EEFF',
            fontColor: '#2E2E2E',
        },
        'action completed': {
            backgroundColor: '#E8EEFF',
            fontColor: '#2E2E2E',
        },
        'force resolved': {
            backgroundColor: '#EEF4DB',
            fontColor: '#196D00',
        },
        'auto resolved': {
            backgroundColor: '#EEF4DB',
            fontColor: '#196D00',
        },
        default: {
            backgroundColor: '#2859E0',
            fontColor: '#FFFFFF',
        },
    },
    severityLevel: {
        default: {
            backgroundColor: '#EAEAEA',
            fontColor: '#15191E',
            textTransform: 'uppercase'
        },
    }
};

export const MAX_COLUMN_SELECTION_COUNT = 16;

export const BATTERY_STATUS_MAP = {
    IDLE: "0",
    DISCHARGING: "2",
    CHARGING: "4",
}

export const PING_STATUS_MAP = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
}

export const TAG_BATTERY_STATUS_MAP = {
    OPERATIONAL: 'Operational',
    NON_OPERATIONAL: 'Non-Operational',
}